import {
  UserModel,
  UpdateUserModel,
  UserResponseModel,
} from "src/app/store/models/user.model";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { LoadingController } from "@ionic/angular/standalone";
import { ToastService } from "../toast-service/toast.service";
import { UPDATE_USER } from "src/app/store/actions/user.action";
import { HttpService } from "../http-service/http-client.service";
import { StorageService } from "../storage-service/storage.service";
import { TranslationModel } from "src/app/store/models/language.model";
@Injectable({
  providedIn: "root",
})
export class LanguageService {
  private store = inject(Store);
  private http = inject(HttpClient);
  translate = inject(TranslateService);
  private httpService = inject(HttpService);
  private toastService = inject(ToastService);
  private storageService = inject(StorageService);
  private loadingCtrl = inject(LoadingController);

  user: UserModel;
  private languageData: TranslationModel = {};
  selectedLanguage = new BehaviorSubject<string>("en");

  constructor() {}

  async setLanguage(langKey: string): Promise<void> {
    this.user = await firstValueFrom(this.store.select("user").pipe(take(1)));
    try {
      const data: any = await firstValueFrom(
        this.http.get(`./assets/i18n/${langKey}.json`),
      );

      this.languageData = data;
      await this.Translate(langKey);
      this.storageService.set("selectedLanguage", langKey);

      if (this.user?.email && this.user.preferences?.language !== langKey) {
        this.updateUserLanguagePreference(this.user.email, langKey);
      }
    } catch (err) {
      this.toastService.toastWarning(
        this.translate.instant("SERVICES_COULD_NOT_FIND_TRANSLATION"),
      );
    }

    // const existingData = await this.storageService.get("languageData");
    // if (existingData && existingData[langKey]) {
    //   this.languageData = existingData[langKey];

    //   await this.Translate(langKey);

    //   if (
    //     this.user &&
    //     this.user.email &&
    //     (!this.user.preferences?.language ||
    //       this.user.preferences.language !== langKey)
    //   ) {
    //     this.updateUserLanguagePreference(this.user.email, langKey);
    //   }
    //   return;
    // }

    // try {
    //   const response: any = await firstValueFrom(
    //     this.httpService.GetTranslation({ lang: langKey }),
    //   );

    //   this.languageData =
    //     typeof response.data === "string"
    //       ? JSON.parse(response.data)
    //       : response.data;

    //   await this.Translate(langKey);

    //   const cachedData = await this.storageService.get("languageData");
    //   const updatedData = {
    //     ...(cachedData || {}),
    //     [langKey]: this.languageData,
    //   };
    //   await this.storageService.set("languageData", updatedData);

    //   if (
    //     this.user &&
    //     this.user.email &&
    //     (!this.user.preferences?.language ||
    //       this.user.preferences.language !== langKey)
    //   ) {
    //     this.updateUserLanguagePreference(this.user.email, langKey);
    //   }
    // } catch (error) {
    //   console.error("Error fetching translation:", error);
    //   this.toastService.toastWarning(
    //     this.translate.instant("SERVICES_COULD_NOT_FIND_TRANSLATION"),
    //   );
    // }
  }

  async Translate(langKey: string): Promise<void> {
    this.translate.setTranslation(langKey, this.languageData, true);
    this.translate.setDefaultLang(langKey);
    await firstValueFrom(this.translate.use(langKey));
    this.selectedLanguage.next(langKey);
    await this.storageService.set("selectedLanguage", langKey);
  }

  async updateUserLanguagePreference(email: string, langKey: string) {
    const payload = {
      id: email,
      language: langKey,
    } as UpdateUserModel;
    this.httpService.UpdateUser(payload).subscribe({
      next: (response: UserResponseModel) => {
        this.user = {
          ...this.user,
          ...response.data,
        };
        this.storageService.set("user", { ...this.user });
        this.store.dispatch(UPDATE_USER({ ...this.user }));
      },
      error: (error) => {},
    });
  }

  // async updateLanguageDataEIJSON(): Promise<void> {
  //   const langCode =
  //     (await this.storageService.get("ei_langCode")) ||
  //     (await this.storageService.get("selectedLanguage"));

  //   return new Promise<void>((resolve, reject) => {
  //     this.http.get(`/assets/i18n/${langCode}.json`).subscribe({
  //       next: (data: any) => {
  //         this.translate.setTranslation(langCode, data);
  //         this.translate.use(langCode);
  //         resolve(); // ✅ wait until language is fully set
  //       },
  //       error: (err) => {
  //         console.error(
  //           `Could not load translation file for '${langCode}'`,
  //           err,
  //         );
  //         resolve(); // or reject(err) if you want to fail fast
  //       },
  //     });
  //   });
  // }
}
